import React from "react";
import Seo from "@/components/Seo";

/** Shared layout for legal documents — Terms, Privacy, Refund.
 *  Pass `title`, optional `subtitle`, and `sections` array.
 *  Each section: { heading, body: string | JSX } — body strings render as paragraphs.
 */
export default function LegalPage({ title, subtitle, sections, lastUpdated, testid, seoPath }) {
  return (
    <div className="v-container" style={{ paddingTop: 80, paddingBottom: 140, maxWidth: 820 }} data-testid={testid}>
      {seoPath && (
        <Seo
          path={seoPath}
          title={`${title} · Verdict`}
          description={subtitle || `${title} for Verdict, the AI-powered packaging audit platform by Therefore Design.`}
        />
      )}
      <div className="overline" style={{ color: "var(--v-accent)" }}>Legal</div>
      <h1 style={{ fontSize: 44, marginTop: 12, lineHeight: 1.08, letterSpacing: "-.02em" }}>{title}</h1>
      {subtitle && <p style={{ color: "var(--v-text-2)", marginTop: 14, fontSize: 15, maxWidth: 640, lineHeight: 1.6 }}>{subtitle}</p>}
      {lastUpdated && <div style={{ marginTop: 14, fontSize: 12, color: "var(--v-text-2)" }}>Last updated: <b style={{ color: "var(--v-text)" }}>{lastUpdated}</b></div>}

      <div style={{ marginTop: 48 }}>
        {sections.map((s, idx) => (
          <div key={s.heading || `section-${idx}`} style={{ borderTop: idx === 0 ? "none" : "1px solid var(--v-border)", paddingTop: idx === 0 ? 0 : 28, marginTop: idx === 0 ? 0 : 28 }}>
            <h3 style={{ fontSize: 18, color: "var(--v-text)" }}>{s.heading}</h3>
            <div style={{ color: "var(--v-text-2)", marginTop: 10, fontSize: 14, lineHeight: 1.7, maxWidth: 720 }}>
              {typeof s.body === "string"
                ? s.body.split("\n\n").map((p, i) => <p key={`${s.heading || idx}-p-${i}`} style={{ margin: i === 0 ? 0 : "12px 0 0 0" }}>{p}</p>)
                : s.body}
            </div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 80, padding: 24, background: "var(--v-bg-2)", border: "1px solid var(--v-border)" }}>
        <div className="overline" style={{ color: "var(--v-text-2)" }}>Need clarification?</div>
        <p style={{ marginTop: 8, fontSize: 13, color: "var(--v-text)" }}>
          Write to <a href="mailto:info@thereforedesign.co.in" style={{ color: "var(--v-accent)" }}>info@thereforedesign.co.in</a>{" "}
          or use our <a href="/support" style={{ color: "var(--v-accent)" }}>support form</a>.
        </p>
      </div>
    </div>
  );
}
